<template>
  <SimplePage title="レスラク接続設定" hideStoreName showBack :onHome="back">
    <template #main>
      <div class="main">
        <div class="sync">
          <p>レスラク連携</p>
          <p class="status">{{ syncStatus }}</p>
        </div>
        <p class="info">
          ※連携を解除する場合や設定を変更する場合は、レスラク問い合わせ：050-1744-6639 受付時間 10 時～18
          時（土日、祝日、夏季・冬季休業日を除く） までご連絡ください
        </p>
        <p>
          予約受付枠に対してレスラク卓を設定してください。<br />
          レスラク管理画面は<BrowserOpen
            class="description"
            :url="isStaging ? 'https://stg.resraku.com/users/sign_in' : 'https://resraku.com/users/sign_in'"
            >こちら</BrowserOpen
          >（safariが立ち上がります）
        </p>
        <SearchBar v-model="inputFilter" placeholder="予約受付枠名" @search="filter = inputFilter" />
        <DataTable
          class="mappings"
          :data="syncGroupingGnavis"
          :columns="[
            { key: 'name', name: '予約受付枠名' },
            { key: 'resrakuTable', name: 'レスラク卓名' },
            { key: 'time', name: '時間' },
            { key: 'week', name: '曜日' },
          ]"
          nodata="該当する予約受付設定はありません"
          selectable
          @select="showTables"
          editButton
          @edit="edit"
          :loading="busy"
        >
          <template #name="{ item }">
            <div class="reception">
              <DropDownIcon :class="['toggle', { open: item.isShowTable }]" />
              <div>
                <p>{{ toEllipsis(item.name, 15) }}</p>
                <p>{{ `定員：${formatRange(item)}名` }}</p>
                <p>{{ `結合：${['不可', '可'][item.seatJoinFlg]}` }}</p>
              </div>
            </div>
          </template>
          <template #resrakuTable="{ item }">
            <div v-if="item.resrakuTables.length === 0">未設定</div>
            <div v-else v-for="table in item.resrakuTables" :key="table.key">
              <p @click.stop>
                <HelpTooltip :message="table.name" container=".vue-recycle-scroller__item-wrapper" scrollHide />
              </p>
              <p>{{ `定員：${formatRange(table)}名` }}</p>
              <p>{{ `結合：${['不可', '可'][table.seatJoinFlg]}` }}</p>
            </div>
          </template>
          <template #time="{ item }">
            <div v-if="item.resrakuTables.length === 0">未設定</div>
            <div v-else v-for="table in item.resrakuTables" :key="table.key">
              <p>{{ `${table.startTime}〜${table.endTime}` }}</p>
            </div>
          </template>
          <template #week="{ item }">
            <div v-if="item.resrakuTables.length === 0">未設定</div>
            <div v-else v-for="table in item.resrakuTables" :key="table.key">
              <p>{{ week(table.day) }}</p>
            </div>
          </template>
          <div slot="after-row" slot-scope="{ item }" v-if="item.isShowTable" class="tables">
            <TableIcon class="tableIcon" />{{ item.tableNames.join('、') }}
          </div>
        </DataTable>
      </div>
      <Dialog
        v-if="alertResrakuModal"
        title="レスラク接続設定"
        message="レスラクからレスラク卓の削除が連携されました。"
        okText="閉じる"
        @ok="closeAlertResrakuModal"
        @close="closeAlertResrakuModal"
      />
    </template>
  </SimplePage>
</template>

<script>
import { mapState } from 'vuex'
import { orderBy } from 'lodash'
import { formatRange } from '@/utils/number'
import { toEllipsis } from '@/utils/string'
import SimplePage from '@/components/templates/SimplePage'
import Dialog from '@/components/molecules/ModalDialog'
import DataTable from '@/components/molecules/DataTable'
import SearchBar from '@/components/molecules/SearchBar'
import HelpTooltip from '@/components/molecules/HelpTooltip'
import DropDownIcon from '@/components/icons/DropDownIcon'
import TableIcon from '@/components/icons/table'
import BrowserOpen from '@/components/atoms/BrowserOpen'

export default {
  name: 'Resraku',
  components: {
    SimplePage,
    DataTable,
    Dialog,
    SearchBar,
    HelpTooltip,
    DropDownIcon,
    TableIcon,
    BrowserOpen,
  },
  data() {
    return {
      inputFilter: '',
      filter: '',
      isShowTables: {},
      alertResrakuModal: false,
    }
  },
  computed: {
    ...mapState({
      mappings: state => state.resraku.list.mappings,
      busy: state => state.resraku.list.busy,
      currentStore: state => state.stores.current.store,
    }),
    syncStatus() {
      return ['未連携', '事前設定中', '一時停止', '連携中'][this.currentStore.syncStatus.resraku]
    },
    syncGroupingGnavis() {
      return orderBy(
        this.mappings
          .map(table => ({
            ...table,
            isShowTable: this.isShowTables[table.id],
          }))
          .filter(table => table.name.includes(this.filter)),
      )
    },
    isStaging() {
      return location.href.includes('test')
    },
  },
  watch: {},
  mounted() {
    this.fetch()
  },
  methods: {
    formatRange,
    toEllipsis,
    async fetch() {
      await this.$store.dispatch('resraku/table/get')
      await this.$store.dispatch('resraku/list/get')
      this.alertResrakuModal = window.gnaviReserveList.alertResraku?.length > 0
    },
    back() {
      location.assign('/store/init')
    },
    edit(table) {
      this.$router.push({ name: 'ResrakuEdit', params: { table } })
    },
    showTables({ id }) {
      this.$set(this.isShowTables, id, !this.isShowTables[id])
    },
    week(days) {
      const dayObj = [1, 2, 3, 4, 5, 6, 0, -1, -2].map(day => ({
        dayKey: day,
        label: { 0: '日', 1: '月', 2: '火', 3: '水', 4: '木', 5: '金', 6: '土', '-1': '祝日', '-2': '祝前日' }[day],
        dayValue: days[day],
      }))
      return (
        dayObj
          .map(day => day.dayValue && day.label)
          .filter(v => v)
          .join('・') || '未設定'
      )
    },
    closeAlertResrakuModal() {
      this.$store.dispatch('alerts/delete', { rsvId: null, type: 27 })
      this.alertResrakuModal = false
    },
  },
}
</script>
<style lang="postcss" scoped>
.main {
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 24px;
}

.sync {
  align-items: center;
  background-color: var(--white);
  display: grid;
  font-size: 21px;
  grid-template-columns: 130px 1fr;
  height: 64px;
  margin-bottom: 12px;
  padding: 0 26px 0 16px;

  .status {
    font-weight: bold;
    justify-self: end;
  }
}

.info {
  font-size: 11px;
  margin-bottom: 24px;
}

.description {
  color: var(--moderate-blue);
  text-decoration: underline;
}

.group {
  & + & {
    margin-top: 24px;
  }
}

.search-bar {
  margin: 18px 0 16px;
}

.toggle {
  fill: var(--very-dark-gray-2);
  height: 24px;
  transform: rotate(-90deg);
  width: 24px;

  &.open {
    transform: rotate(0);
  }
}

.tables {
  background-color: var(--mostly-white);
  box-sizing: border-box;
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 16px 1fr;
  line-height: 1.4;
  min-height: 48px;
  padding: 16px 48px;
}

.tableIcon {
  fill: var(--very-dark-gray-2);
  height: 16px;
  margin: 2px;
  width: 16px;
}

.reception {
  display: flex;
  flex: 1 1 auto;
  gap: 8px;
  padding: 16px;
}

>>> .name {
  min-width: 264px;
  width: 264px;
}

>>> .resrakuTable {
  min-width: 264px;
}

>>> .time {
  min-width: 144px;
  width: 144px;
}

>>> .week {
  min-width: 248px;
  width: 248px;
}

>>> .edit {
  min-width: 56px;
  width: 56px;
}

>>> td.name {
  padding: 0;
}

>>> td.time > div,
>>> td.week > div {
  align-items: center;
}

>>> td.resrakuTable,
>>> td.time,
>>> td.week {
  flex-direction: column;
  padding: 0;

  > div {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;
    padding: 16px;
    width: 100%;
    &:not(:first-of-type) {
      border-top: solid 1px var(--border-color);
    }
  }
}
</style>
